import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navigationLinks, companyInfo } from '../data/mock';
import { Button } from './ui/button';
import ContactModal from './ContactModal';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-slate-100' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img 
              src="/images/logo.svg" 
              alt="Mainet Makelaars"
              className="h-9 md:h-11 w-auto transition-all duration-300"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10">
            {navigationLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className="relative text-[13px] font-medium tracking-[0.12em] text-slate-500 hover:text-[#1a2e4a] transition-colors duration-300 uppercase after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-[1.5px] after:bg-[#10b981] hover:after:w-full after:transition-all after:duration-300"
              >
                {link.label}
              </a>
            ))}
            <ContactModal>
              <Button 
                className="bg-[#1a2e4a] hover:bg-[#0f1d30] text-white font-medium tracking-[0.1em] uppercase text-[13px] px-7 py-2.5 transition-all duration-300 hover:shadow-lg hover:shadow-[#1a2e4a]/20"
              >
                Get in Touch
              </Button>
            </ContactModal>
          </nav>

          {/* Mobile */}
          <div className="flex md:hidden items-center gap-2">
            <ContactModal>
              <Button 
                className="bg-[#1a2e4a] hover:bg-[#0f1d30] text-white font-medium tracking-[0.08em] uppercase text-xs px-4 py-2 transition-all duration-300"
              >
                Contact
              </Button>
            </ContactModal>
            <button
              className="p-2 text-[#1a2e4a]"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-slate-100 animate-fade-in">
            <nav className="flex flex-col gap-1">
              {navigationLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  className="text-sm font-medium tracking-[0.1em] text-slate-600 hover:text-[#1a2e4a] hover:bg-slate-50 transition-all duration-300 uppercase py-3 px-3 rounded"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
